module.exports = __webpack_public_path__ + "images/emoji/heartpulse.913f58291b8cf038cde0.png";